import { Component } from '@angular/core';
import { SessionOptionsComponent } from "../session-options/session-options.component";
import { CesiumService } from '../../../core/services/cesium.service';

@Component({
  selector: 'app-arclive-view',
  standalone: true,
  imports: [SessionOptionsComponent],
  providers: [CesiumService],
  templateUrl: './arclive-view.component.html',
  styleUrl: './arclive-view.component.css'
})
export class ArcliveViewComponent {

}
